module.exports = __webpack_public_path__ + "static/media/USA.a2e108b4.png";